import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import styles from './WelcomeSection.module.css';

export const WelcomeSection = () => {
  const navigate = useNavigate();

  return (
    <section className={styles.welcome}>
      <div className={styles.welcomeHeader}>
        <div>
          <h1 className={styles.title}>
            Welcome to <span className={styles.brandHighlight}>GapSense</span>
          </h1>
          <p className={styles.subtitle}>
            Professional compliance gap analysis at your fingertips
          </p>
        </div>
        <Button
          label="New Analysis"
          icon="pi pi-plus"
          className={styles.primaryButton}
          onClick={() => navigate('/analyses/create')}
        />
      </div>
    </section>
  );
};
